import { z } from 'zod';

export type DocumentItem = z.infer<typeof documentItemSchema>;

export const documentItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  title: z.string(),
  link: z.string(),
  version: z.string(),
  changes: z.string().optional(),
});

export const documentSchema = z.array(documentItemSchema);

export const documents = {
  getDocument: {
    path: (name: string) => `legal-documents/v1/doc/${name}`,
  },
  consentToDoc: {
    path: (docId: string) => `legal-documents/v1/consent/${docId}`,
  },
  pendingConsentDoc: {
    path: `legal-documents/v1/consent?pending=true`,
    schema: documentSchema,
  },
  latestDocs: { path: `legal-documents/v1/latest`, schema: documentSchema },
};
